import React, { Component } from 'react';
import { connect } from 'react-redux';
import CreditActions from './CreditActions.jsx';

class MessageBar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { name, second_book, third_book, computedCart, store_bundle_pricing, upgradeStatus, customer, isLoggedIn, path, storeType, store_tla } = this.props;
    let message     = '';
    let nBoxItems   = [];
    computedCart.items.forEach( i => {
      if( i && i.quantity && i.quantity > 1 ) new Array(i.quantity - 1).fill().map( x => nBoxItems.push(i) );
      nBoxItems.push( i );
    });
    let actualBoxItems = nBoxItems.filter( x => x).length;
    let sFirstName  = customer.first_name;
    let isNegOp     = storeType === "Negative Option" && customer.fulfillment_type === "Negative";
    let product_name = store_tla === "DVD" ? 'DVD': 'book';
    let product_name_ex = store_tla === "DVD" ? 'DVDs': 'book';
    let any         = store_tla === "DVD" ? "select" : "any";
    let Featured    = store_tla === "DVD" ? "Director's" : "Featured";
    let the         = store_tla === "DVD" ? "" : "the";

    if (isLoggedIn && !upgradeStatus && (customer.status !== "Pending" && customer.status !== "Cancelled")) {
      // Check if box is full
      if ( nBoxItems.length >= 12 && nBoxItems[0]){
          message = 'Your box is full, you are now ready to check out.';
      } else if( store_bundle_pricing ){
        // Check if on feature section and no catalog item has been choosen
        if ( path === '/' && !nBoxItems[0] && !nBoxItems[1]  ) {
          message = 'Welcome back, ' + sFirstName + '! Choose a ' + Featured + ' Selection to unlock Bundle Prices!';
        } else {
          // Check if a catalog item has been selected and message price accordingly
          //No Featured Selection Choosen
          if(!nBoxItems[0]){
            if(!nBoxItems[0] && nBoxItems[1] && !nBoxItems[2]){
              message = 'You’re missing out on ' + Featured + ' Selection Bundle Prices—add a ' + Featured + ' Selection to save!';
            } else if(!nBoxItems[0] && nBoxItems[1] && nBoxItems[2]){
              message = 'Add a ' + Featured + ' Selection to unlock Bundle Prices!';
            } else {
              message = 'Choose a Featured Selection to unlock Bundle Prices!'
            }
          } else {
            if(!nBoxItems[1]) // fs and missing 2 books
              message = 'Congratulations ' + sFirstName + ', you’ve unlocked ' + Featured + ' Selection Bundle prices! Add any ' + product_name + ' from the Catalog for only $' + second_book + '.';
            else if (!nBoxItems[2]) // 2 out of 3 books
              message = 'Excellent! Now you can add a third ' + product_name + ' for only $' + third_book + '!';
            else // all 3 books
              message = "You've unlocked " + Featured + " Selection bundle pricing!";
          }
        }
      } else {
        if ( actualBoxItems === 0 )
          message = 'Welcome back, ' + sFirstName + '! Choose a ' + Featured + ' Selection to begin saving.';
        else if( actualBoxItems < 2 || computedCart.subtotal < 35  )
          message = 'Thanks, ' + sFirstName + '! Add one more title to get Free Shipping.';
        else
          message = "Congratulations! You’ve unlocked Free Shipping. Add more titles to continue to shop and save.";
      }
    } else {
    // Show enroll cart messaging
      if(nBoxItems[0] && nBoxItems[1]){
        message = 'Click “Join Now” to become a member of ' + the + ' ' + name +'!';
      } else {
        if ( !nBoxItems[0] ){
          message = 'Add ' + any + ' ' + product_name_ex + ' for $' + second_book + ' each to get started';
        } else {
          message = 'Add a second ' + product_name + ' for $' + second_book + ' + Free Shipping';
        }
      }
    }
    return (
        <div className="message-bar" >
          <h4 className="message">{message}</h4>
        </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'path': state.path,
      'second_book': state.store.second_book,
      'third_book': state.store.third_book,
      'name': state.store.name,
      'store_bundle_pricing': state.store.bundle_pricing,
      'customer': state.customer,
      'isLoggedIn': state.isLoggedIn,
      'computedCart': state.computedCart,
      'upgradeStatus': state.upgradeStatus,
      'store_tla': state.store.tla,
      'storeType': state.store.type
    };
}

export default connect(mapStateToProps)(MessageBar);


// WEBPACK FOOTER //
// ./src/components/MessageBar.jsx